/**
 * Utility for image validation and client-side compression/resizing
 */

export const validateImage = (file, maxSizeMB = 2) => {
  if (!file) return null;
  
  if (!file.type.startsWith('image/')) {
    return 'File must be an image';
  }
  
  if (file.size > maxSizeMB * 1024 * 1024) {
    return `Image size should be less than ${maxSizeMB}MB`;
  }
  
  return null;
};

export const resizeImage = (file, maxWidth = 1200, maxHeight = 1200, quality = 0.8) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        if (width > height) {
          if (width > maxWidth) {
            height *= maxWidth / width;
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width *= maxHeight / height;
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        const dataUrl = canvas.toDataURL('image/jpeg', quality);
        resolve(dataUrl);
      };
      img.onerror = (err) => reject(err);
    };
    reader.onerror = (err) => reject(err);
  });
};

export const handleImageUpload = async (file, options = {}) => {
  const { maxSizeMB = 2, maxWidth = 1200, maxHeight = 1200, quality = 0.8 } = options;
  
  const error = validateImage(file, maxSizeMB);
  if (error) throw new Error(error);
  
  return await resizeImage(file, maxWidth, maxHeight, quality);
};
